import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import OpportunitySearchParams from './OpportunitySearchParams';
import OpportunityService from '../../../Services/opportunityService';
import OpportunityItem from '../../../Domain/OpportunityItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditOpportunityWindowDescription from './EditOpportunityWindowDescription';
import AdminEditOpportunityWindowDescription from './AdminEditOpportunityWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import OpportunityStatusChangeWindowDescription from './OpportunityStatusChangeWindowDescription';
import OpportunityStatusChangeItem from '../../../Domain/OpportunityStatusChangeItem';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import urlHelper from '../../../Helpers/urlHelper';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ServiceListItem from '../../../Domain/ServiceListItem';
import EditServiceDescription from '../ServiceAdmin/EditServiceDescription';
import ErrorMessage from '../../../Elements/ErrorMessage';
import OfficeService from '../../../Services/OfficeService';
import OpportunitySecurityChecklistService from '../../../Services/opportunitySecurityChecklistService';
import OpportunitySecurityChecklistItem from '../../../Domain/OpportunitySecurityChecklistItem';
import EditOpportunitySecurityChecklistWindowDescription from './EditOpportunitySecurityChecklistWindowDescription';
import LoadingFullScreen from '../../../Elements/LoadingFullScreen';
import OpportunityPOCExportSearchParams from './OpportunityPOCExportSearchParams';
import OpportunityPOCExportWindowDescription from './OpportunityPOCExportWindowDescription';
import OpportunityStatusEnum from '../../../Enums/OpportunityStatusEnum';
import SendScheduleEdLinkWindowDescription from './SendScheduleEdLinkWindowDescription';
import OpportunityScheduleEdLinkItem from '../../../Domain/OpportunityScheduleEdLinkItem';
import OpportunityScheduleEdService from '../../../Services/opportunityScheduleEdService';

class OpportunityAdmin extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      numberOfElementsInTheTable: 0,
      numberOfElementsOnAPage: 20,
      opportunityList: [],
      // Deep-link seed for global record search (CD-5425), on the opportunity id, which the grid's
      // own OpportunityName field resolves as an id. Skipped in embedded mode (Navigation), where the
      // host has already scoped the list to one client.
      searchItem:
        this.props.Navigation === true
          ? { ClientId: this.props.ClientId }
          : new URLSearchParams(window.location.search).get('OpportunityName')
          ? { OpportunityName: new URLSearchParams(window.location.search).get('OpportunityName') }
          : new OpportunitySearchParams(),
      selected: -1,
      selectedItem: null,
      selectedSecurityChecklistItem: null,
      selectedScheduleEdLinkItem: null,
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      loading: false,
    };

    this.showPanel = this.showPanel.bind(this);
    this.buttonFunctions = this.buttonFunctions.bind(this);
    this.refresh = this.refresh.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    OpportunityItem.editGeneralFunction = this.editGeneralFunction.bind(this);
    OpportunityItem.ExtendActualEndDate = this.ExtendActualEndDate.bind(this);
    OpportunityItem.opportunityStatusChangeFunction = this.opportunityStatusChangeFunction.bind(this);
    OpportunityItem.createServiceFunction = this.createServiceFunction.bind(this);
    // OpportunityItem.opportunitySecurityChecklistFunction = this.opportunitySecurityChecklistFunction.bind(this);
    OpportunityItem.editOpportunitySecurityChecklistFunction = this.editOpportunitySecurityChecklistFunction.bind(this);
    OpportunityItem.sendScheduleEdLinkFunction = this.sendScheduleEdLinkFunction.bind(this);
    OpportunityItem.generateScheduleEdMsaFunction = this.generateScheduleEdMsaFunction.bind(this);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  setMaxDuration(panel, selected) {
    OfficeService.GetOfficeGlobalData()
      .then((officeGlobalData) => {
        const maxInterval = officeGlobalData.maximumOpportunityDuration;
        selected.MaximumOpportunityDuration = maxInterval;
        this.setState({
          selectedItem: selected,
          shownPanel: panel,
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('OA69'));
  }

  buttonFunctions(key) {
    if (ShownPanelsEnum.AddNewItem === key) {
      const newopportunity = new OpportunityItem();
      newopportunity.ClientId = this.props.ClientId ? this.props.ClientId : this.state.itemList[0].ClientId;
      newopportunity.LeadId = this.props.LeadId;
      newopportunity.OfficeId = this.props.OfficeId
        ? this.props.OfficeId
        : this.state.itemList[0].PrimarySalesRepOfficeId;

      OfficeService.GetOfficeBillingCurrency(newopportunity.OfficeId)
        .then((currency) => {
          if (!currency) {
            ErrorMessage.SetErrorMessage('No billing currency found for the office');
            return;
          }
          newopportunity.BillingCurId = currency.currencyId;
          this.setMaxDuration(key, newopportunity);
          this.setState({ selectedItem: newopportunity });
          this.showPanel(key);
        })
        .catch((error) => ErrorMessage.SetErrorMessage('OA89', error));
      return;
    }
    this.showPanel(key);
  }

  editGeneralFunction(id, item) {
    this.setMaxDuration(ShownPanelsEnum.Edit, item);
  }

  editOpportunitySecurityChecklistFunction(id, item) {
    this.setState({ loading: true });

    OpportunitySecurityChecklistService.GetById(id)
      .then((result) => {
        // No checklist yet comes back as an EMPTY resource, which would open the wizard on empty required fields -
        // so a create builds a blank item instead of one from that resource.
        const resourceItem = result?.opportunitySecurityChecklistId
          ? new OpportunitySecurityChecklistItem(result)
          : new OpportunitySecurityChecklistItem();
        resourceItem.OpportunityId = item.OpportunityId;
        resourceItem.ClientId = item.ClientId;

        this.setState({
          selectedSecurityChecklistItem: resourceItem,
          shownPanel: ShownPanelsEnum.EditSecurityChecklist,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  // No fetch needed: the row already carries the client and the sent flag.
  sendScheduleEdLinkFunction(id, item) {
    this.setState({
      selectedScheduleEdLinkItem: new OpportunityScheduleEdLinkItem(item),
      shownPanel: ShownPanelsEnum.SendScheduleEdLink,
    });
  }

  // Generate MSA (CD-5437): no input to collect, so a confirmation rather than a wizard - and confirmed at all
  // because issuing the MSA closes the Schedule D/E section one-way.
  generateScheduleEdMsaFunction(id) {
    ErrorMessage.SetApprove(
      'This will generate the pre-filled MSA from the latest Schedule D/E submission and attach it to the ' +
        'Opportunity. It also closes the Schedule D/E section: no further link can be sent and no second MSA ' +
        'can be generated. Do you want to proceed?',
      () => this.generateScheduleEdMsa(id)
    );
  }

  generateScheduleEdMsa(id) {
    this.setState({ loading: true });
    OpportunityScheduleEdService.GenerateMsa(id)
      .then((response) => {
        this.setState({ loading: false });
        if (response?.error) {
          ErrorMessage.SetWarning(response.error);
          return;
        }
        ErrorMessage.SetSuccessMessage(
          `The pre-filled MSA has been generated and attached to the Opportunity (${response.fileName}). ` +
            'You can download it from the Attachments tab.'
        );
        // ScheduleEDMsaIssued has changed server-side and drives both Schedule D/E menu items.
        this.refresh();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  ExtendActualEndDate(id, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditSubItem,
      selectedItem: item,
    });
  }

  opportunityStatusChangeFunction(id, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedItem: item,
    });
  }

  createServiceFunction(id, item) {
    this.setState({
      selected: id,
      selectedItem: item,
      shownPanel: ShownPanelsEnum.AddNewSubItem,
    });
  }
  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderServiceCreatePanel() {
    if (
      this.state.selectedItem.StatusCode === OpportunityStatusEnum.OpportunityWon ||
      this.state.selectedItem.StatusCode === OpportunityStatusEnum.OpportunityLost
    )
      return null;
    const serviceItem = new ServiceListItem();
    serviceItem.OpportunityId = this.state.selectedItem.OpportunityId;
    serviceItem.OpportunityName = this.state.selectedItem.Name;
    return (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={serviceItem}
        clickOnCancel={this.editPanelOnClose.bind(this)}
        clickOnSave={this.savePanelOnClose.bind(this)}
        windowDescription={EditServiceDescription}
        errorCode={'OA106'}
      />
    );
  }

  renderPanels() {
    switch (this.state.shownPanel) {
      case ShownPanelsEnum.Edit:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditOpportunityWindowDescription}
            errorCode={'OA121'}
          />
        );
      case ShownPanelsEnum.EditSubItem:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={AdminEditOpportunityWindowDescription}
            errorCode={'OA132'}
          />
        );
      case ShownPanelsEnum.AddNewItem: {
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditOpportunityWindowDescription}
            errorCode={'OA150'}
          />
        );
      }
      case ShownPanelsEnum.StatusUpdate:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={new OpportunityStatusChangeItem(this.state.selectedItem)}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={OpportunityStatusChangeWindowDescription}
            approveBeforeSaveCheck={OpportunityStatusChangeWindowDescription.shouldConfirmOldActualCloseDate}
            approveBeforeSaveMessage={OpportunityStatusChangeWindowDescription.buildOldActualCloseDateWarning(
              this.state.selectedItem.ActualCloseOn
            )}
            errorCode={'OA228'}
          />
        );
      case ShownPanelsEnum.AddNewSubItem:
        return this.renderServiceCreatePanel();
      case ShownPanelsEnum.EditSecurityChecklist:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedSecurityChecklistItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditOpportunitySecurityChecklistWindowDescription}
            errorCode={'OA235'}
          />
        );
      case ShownPanelsEnum.SendScheduleEdLink:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedScheduleEdLinkItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={SendScheduleEdLinkWindowDescription}
            approveBeforeSaveCheck={SendScheduleEdLinkWindowDescription.shouldConfirmResend}
            approveBeforeSaveMessage={SendScheduleEdLinkWindowDescription.resendWarning}
            errorCode={'OA262'}
          />
        );
      case ShownPanelsEnum.OpportunityPOCExport:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new OpportunityPOCExportSearchParams(true)}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={OpportunityPOCExportWindowDescription}
            errorCode='OA255'
          />
        );
      default: {
        return '';
      }
    }
  }

  savePanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    this.refresh();
  }

  editPanelOnClose(refresh) {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    if (refresh) this.refresh();
  }

  closeOverWindowWithRefresh() {
    this.closeOverWindowWithoutRefresh();
    this.refresh();
  }

  closeOverWindowWithoutRefresh() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
  }

  handleExportExcelButtonClick() {
    OpportunityService.ExportAdminExcelAsync(this.state.searchItem).catch(() => ErrorMessage.SetErrorMessage('LA139'));
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  renderButtonsAndPanels() {
    if (this.props.Navigation) {
      const href =
        this.props.ClientId === ''
          ? ''
          : urlHelper.getProperUrl('sales_opportunities/search', `ClientId=${this.props.ClientId}`);

      return (
        <>
          <ButtonRow
            tooltips={['Create', '']}
            labels={['', 'Opportunities']}
            colors={[ButtonColorsEnum.Primary, ButtonColorsEnum.Secondary]}
            keys={[ShownPanelsEnum.AddNewItem, ShownPanelsEnum.Navigate]}
            className={'InnerMenuButtonFigmaList'}
            icons={['fa-solid fa-plus-circle', '']}
            roleKeys={['sales_opportunities_button', '']}
            value={this.state.shownPanel}
            onClick={this.buttonFunctions}
            href={[null, href]}
            disabled={[
              !this.props.ClientId ||
                this.state.itemList.some(
                  (item) => this.state.itemList.length > 0 && item.ClientId !== this.state.itemList[0].ClientId
                ),
              false,
            ]}
          />
          {this.renderPanels()}
        </>
      );
    }

    return (
      <>
        <ButtonRow
          tooltips={['Create', 'POC Export']}
          labels={['', 'POC Export']}
          colors={[ButtonColorsEnum.Primary, ButtonColorsEnum.Secondary]}
          keys={[ShownPanelsEnum.AddNewItem, ShownPanelsEnum.OpportunityPOCExport]}
          icons={['fa-solid fa-plus-circle', 'fa-solid fa-file-export']}
          roleKeys={['sales_opportunities_button', 'report_opportunitypocexport_run']}
          value={this.state.shownPanel}
          onClick={this.buttonFunctions}
          className={''}
          disabled={[
            this.state.itemList.length < 1 ||
              this.state.itemList.some(
                (item) => this.state.itemList.length > 0 && item.ClientId !== this.state.itemList[0].ClientId
              ),
            false,
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return this.state.loading ? (
      <LoadingFullScreen />
    ) : (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={OpportunityItem}
          serviceFunction={OpportunityService.GetOpportunityItemList}
          convertDBItemsFunction={OpportunityService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={OpportunitySearchParams}
          showSearchStrip={true}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy='OpportunityId'
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          singleSearchLine={true}
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='reports_opportunityexport'
          singleSearchLinePlaceholder='Search in Opportunity Id, Opportunity Name, Client Name or Status fields...'
          errorCode='OA248'
        />
      </div>
    );
  }
}

export default OpportunityAdmin;
